import InputAdornment from '@mui/material/InputAdornment';
import MuiTextField from '@mui/material/TextField';
import { FC, useRef } from 'react';

export enum TextInputType {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email'
}
interface TextFieldProps {
  data: {
    name: string;
    placeholder: string;
    value: string | number | null;
    error?: string | null;
    endAdornmentText?: string | React.SVGProps<SVGSVGElement>;
  };
  config: {
    type?: TextInputType;
    isArabic?: boolean;
    isDisabled?: boolean;
    isMultiLine?: boolean;
    isRequired?: boolean;
  };
  eventHandlers: {
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

const TextField: FC<TextFieldProps> = ({ data, config, eventHandlers }) => {
  const { name, placeholder, value, error, endAdornmentText } = data;
  const {
    isArabic,
    type = '',
    isDisabled = false,
    isMultiLine = false,
    isRequired = false
  } = config;
  const { handleInputChange } = eventHandlers;

  const inputRef = useRef<HTMLInputElement | null>(null);

  // Prevent scrolling on the number input field
  const handleNumberInputScroll = (e: React.WheelEvent<HTMLInputElement>) => {
    if (type === TextInputType.NUMBER && inputRef.current) {
      e.preventDefault();
      inputRef.current.blur();
    }
  };

  return (
    <MuiTextField
      required={isRequired}
      dir={isArabic ? 'rtl' : ''}
      disabled={isDisabled}
      variant="outlined"
      placeholder={placeholder}
      label=""
      name={name}
      value={value}
      inputRef={inputRef}
      autoComplete="off"
      multiline={isMultiLine}
      minRows={isMultiLine ? 4 : 2}
      maxRows={isMultiLine ? 6 : 4}
      inputProps={{
        autoComplete: 'off',
        type: type,
        min: 0,
        onWheel: handleNumberInputScroll
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            sx={{
              cursor: 'pointer'
            }}
            position="end"
          >
            {endAdornmentText as any}
          </InputAdornment>
        )
      }}
      onChange={handleInputChange}
      helperText=" "
      {...(error && { error: true, helperText: error })}
      sx={{
        '& .MuiOutlinedInput-root': {
          ...(isMultiLine && { p: 1 })
        }
      }}
    />
  );
};
export default TextField;
